import { dataUserSettingsSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserSettingsSolid = /*#__PURE__*/createIcon(dataUserSettingsSolid)
export default IconUserSettingsSolid
